import { ADMIN_FUNCTIONS, SC_MODULES } from '@app/constants/sc.modules';
import settingIcon from '@app/assets/images/icons/cfg/settings.svg';
import SettingSchool from '@modules/school-service/pages/SettingGroup/SettingSchoolPage';
import { IRouteConfig } from '../route.types';
import InvoiceFormPage from '@modules/school-service/pages/SettingGroup/InvoiceFormPage';

/**
 * Cấu hình
 */
const settingRoutes: IRouteConfig[] = [
    {
        name: 'THIẾT LẬP HỆ THỐNG',
        icon: settingIcon,
        isMenu: true,
        isRoute: false,
        exact: false,
        moduleId: SC_MODULES.SERVICE,
        children: [
            {
                name: 'Thiết lập thông tin trường học',
                isMenu: true,
                isRoute: true,
                exact: false,
                functionId: ADMIN_FUNCTIONS.SETTINGS,
                link: '/setting',
                path: '/setting',
                main: () => <SettingSchool />,
            },
            {
                name: 'Thiết lập hóa đơn bán hàng',
                link: '/invoice-form',
                path: '/invoice-form',
                isMenu: true,
                isRoute: true,
                exact: false,
                functionId: ADMIN_FUNCTIONS.SETTINGS,
                main: () => <InvoiceFormPage />,
            },
        ],
    },
];

export default settingRoutes;
